module.exports = __webpack_public_path__ + "img/dead_stock.2ae140de.svg";